/* eslint-disable no-shadow */
const moment = require('moment-timezone');

const state = {
    items: [],
};

const actions = {
    add({ commit }, { title, message }) {
        const item = {
            time: moment.now(),
            title,
            message,
        };
        commit('add', item);
    },
    remove({ commit }, time) {
        commit('delete', time);
    },
};

const mutations = {
    add(state, message) {
        state.items.push(message);
    },
    delete(state, time) {
        const index = state.items.findIndex(item => item.time === time);
        state.items.splice(index, 1);
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
